import { v4 as uuidv4 } from 'uuid';
import * as types from './actionTypes';

export function addSession(session_id){
  return{
    type: types.ADD_SESSION,
    session_id,
  }
}

export function removeSession(){
  return{
    type: types.REMOVE_SESSION,
  }
}

export function createSession() {
  return function(dispatch) {
    const session_id = uuidv4()
    dispatch(addSession(session_id))
    return session_id
  }
}